import React, { Component } from 'react';
import { connect } from 'react-redux';

import { prepareNum, isICCorCSA } from '@services/helper.service';
import './styles.scss';

import {
  setCalculateGridSelectedItem,
  scrollToSelectedResult,
  setCalculateFilter,
  getErrorMessages
} from '@reducers/selectors/calculate/actions';
import { APP_TYPES, defaultUnits } from "../../../../app.config";
import { unitTransform, getInteractionMaximumValue } from '@services/helper.service';
import { setSortingMethod } from '@reducers/web-services/calculate/actions';
import { APP_TEXTS } from '../../../../texts/texts';
import { DISTANCE } from '@reducers/units';
import { isArray } from 'util';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../texts/tooltips';

const STATUS_LIST = ['icon_uncheck', 'icon_check', 'icon_invalid', 'icon_timeout'];

const ALL = 'ALL';

const RESULTS = {
  [ALL]: [],
  OK: [1],
  NOT_OK: [0, 2],
  TIMEOUT: [3]
};

const STEEL_TYPES = {
  'High corrosion steel': 'HCRSteel',
  'Hot dip galvanised': 'HotDipGalvanized',
  'Stainless steel': 'StainlessSteel',
  'Zinc coated steel': 'ZincCoatedSteel'
};

const Filters = {
  status: 'status',
  steelType: 'steelType',
  diameter: 'diameter',
  anchorType: 'anchorType',
  product: 'product',
  productRange: 'productRange'
};

class CalculateAnchorSelection extends Component {

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      chosenSteelType: null,

      // sortBy: null,
      // isReverse: true,

      // results: ALL,
      // anchorType: ALL,
      // steelType: ALL,
      // products: ALL,
      // diameters: ALL,
      // productRange: ALL
    };
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.props.refreshSelectedResult) {
      this.props.scrollToSelectedResult(false);
      this.scrollToSelectedRow();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this._isMounted) {
      if (this.props.filters.status !== prevProps.filters.status ||
        this.props.filters.anchorType !== prevProps.filters.anchorType ||
        this.props.filters.steelType !== prevProps.filters.steelType ||
        this.props.filters.product !== prevProps.filters.product ||
        this.props.filters.diameter !== prevProps.filters.diameter ||
        this.props.filters.productRange !== prevProps.filters.productRange) {
        this.selectFirstResult(); // VladP: Select first result after changing a filter
      }
      else if (this.props.refreshSelectedResult) {
        this.props.scrollToSelectedResult(false);
        this.scrollToSelectedRow();
      }
      else if (prevProps.isWaiting === true && this.props.isWaiting === false) {// waiting for calculation to complete
        this.scrollToSelectedRow();
      }
      if (prevProps.appType !== this.props.appType) // reset row after changing the application
        this.selectedRow = null;

      if (this.props.selectedItem &&
        this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT &&
        this.props.distanceUnit !== prevProps.distanceUnit) {
        this.props.getErrorMessages(this.props.selectedItem);
      }
    }
  }

  render() {
    return (
      <div className="calculation">
        <section className="list-type calculate-anchor-selection">
          {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
            <section className="d-flex filters-section">
              <div className="filters d-flex flex-wrap">
                <select name="results" value={this.props.filters.status} onChange={e => this.chooseResult(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_RESULTS.Content}</option>
                  {this.filteredData(Filters.status).some((res) => RESULTS.OK.indexOf(res.Status) > -1) && (
                    <option value="OK">{APP_TEXTS.ANCHOR_SELECTION_OK.Content}</option>
                  )}
                  {this.filteredData(Filters.status).some((res) => RESULTS.NOT_OK.indexOf(res.Status) > -1) && (
                    <option value="NOT_OK">{APP_TEXTS.ANCHOR_SELECTION_NOT_OK.Content}</option>
                  )}
                  {this.filteredData(Filters.status).some((res) => RESULTS.TIMEOUT.indexOf(res.Status) > -1) && (
                    <option value="TIMEOUT">{APP_TEXTS.ANCHOR_SELECTION_TIMEOUT.Content}</option>
                  )}
                </select>

                <select name="productRanges" value={this.props.filters.productRange}
                  onChange={e => this.chooseProductRange(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_PRODUCT_RANGES.Content}</option>
                  {Object.keys(this.props.filterOptions.productRanges).sort(function (a, b) {
                    return a.localeCompare(b);
                  }).map(pRange =>
                    this.filteredData(Filters.productRange).some(res => res.AnchorProductRange === pRange) && (
                      <option value={pRange} key={pRange}>{pRange}</option>
                    ))}
                </select>

                <select name="products" value={this.props.filters.product} onChange={e => this.chooseProducts(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_PRODUCTS.Content}</option>
                  {Object.keys(this.props.filterOptions.products).sort(function (a, b) {
                    return a.localeCompare(b);
                  }).map(product =>
                    this.filteredData(Filters.product).some(res => res.AnchorProduct === product) && (
                      <option value={product} key={product}>{product}</option>
                    ))}
                </select>

                <select name="chosenSteelType" value={this.props.filters.steelType} onChange={e => this.chooseSteelType(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_STEEL_TYPE.Content}</option>
                  {this.props.steelTypes.map(type =>
                    this.filteredData(Filters.steelType)
                      .some(res => res.Filters_Data != null && res.Filters_Data[STEEL_TYPES[type.InternalName]]) && (
                      <option value={type['InternalName']} key={type['InternalName']}>{type['RunName']}</option>
                    ))}
                </select>

                <select name="anchorType" value={this.props.filters.anchorType} onChange={e => this.chooseAnchorType(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ANCHOR_TYPE.Content}</option>
                  {Object.keys(this.props.filterOptions.anchorType).sort(function (a, b) {
                    return a.localeCompare(b);
                  }).map(type =>
                    this.filteredData(Filters.anchorType).some(res => res.AnchorFamily === type) && (
                      <option value={type} key={type}>{type}</option>
                    ))}
                </select>

                <select name="diameters" value={this.props.filters.diameter} onChange={e => this.chooseDiameter(e.target.value)}>
                  <option value={ALL}>{APP_TEXTS.ANCHOR_SELECTION_ALL_DIAMETERS.Content}</option>
                  {Object.keys(this.props.filterOptions.diameters).sort(function (a, b) {
                    if (+a && +b)
                      return a - b;
                    else
                      return a.localeCompare(b);
                  }).map(diam => this.filteredData(Filters.diameter).some(res => res.AnchorDiameter === parseFloat(diam)) && (
                    <option value={parseFloat(diam)} key={parseFloat(diam)}>
                      {isICCorCSA(this.props.designStandard) ?
                        (unitTransform(parseFloat(diam), true)
                          .from(defaultUnits.DISTANCE)
                          .to(this.props.distanceUnit === DISTANCE.INCHES ? DISTANCE.FRACTIONAL_INCHES : this.props.distanceUnit)) :
                        ("M" + prepareNum(parseFloat(diam), false))}
                    </option>
                  ))}
                </select>

                <button onClick={this.clearFilter}>{APP_TEXTS.ANCHOR_SELECTION_BUTTON_REMOVE_FILTERS.Content}</button>
              </div>
              {/* <div className="description d-flex flex-column">
                <div>&Phi; {APP_TEXTS.ANCHOR_SELECTION_THREADED_DIAMETER.Content}</div>
                <div>{APP_TEXTS.ANCHOR_SELECTION_DF_CLEARANCE_DIAMETER.Content}</div>
              </div> */}
            </section>
          )}

          <table className="fixed_headers calculate-anchor-selection__table">
            <thead className="thead">
              {this.props.appType === APP_TYPES.REBAR_REINFORCEMENT && (
                <tr className="rebar">
                  <th onClick={() => this.props.setSortBy('Status')}>
                    {APP_TEXTS.ANCHOR_SELECTION_OK.Content} {this.getSortingArrow('Status')}
                  </th>
                  <th onClick={() => this.props.setSortBy('DisplayName')}>
                    {APP_TEXTS.ANCHOR_SELECTION_PRODUCT.Content} {this.getSortingArrow('DisplayName')}
                  </th>
                  <th onClick={() => this.props.setSortBy('Diameter')}>
                    <Phi /> {this.getSortingArrow('Diameter')}
                  </th>
                  <th onClick={() => this.props.setSortBy('Lbd')}>
                    {APP_TEXTS.ANCHOR_SELECTION_ANCHORAGE_LBD.Content} {this.getSortingArrow('Lbd')}
                  </th>
                </tr>
              )}

              {this.props.appType !== APP_TYPES.REBAR_REINFORCEMENT && (
                <tr>
                  <th onClick={() => this.props.setSortBy('Status')}>
                    {APP_TEXTS.ANCHOR_SELECTION_OK.Content} {this.getSortingArrow('Status')}
                  </th>
                  <th onClick={() => this.props.setSortBy('AnchorProduct')}>
                    {APP_TEXTS.ANCHOR_SELECTION_PRODUCT.Content} {this.getSortingArrow('AnchorProduct')}
                  </th>
                  <th onClick={() => this.props.setSortBy('AnchorType')}>
                    {APP_TEXTS.ANCHOR_SELECTION_DIMENSION.Content} {this.getSortingArrow('AnchorType')}
                  </th>
                  <Tooltip content={"&Phi;" + APP_TOOLTIPS.TOOLTIP_THREADED_DIAMETER.Content}>
                    <th onClick={() => this.props.setSortBy('AnchorDiameter')}>
                      <Phi /> {this.getSortingArrow('AnchorDiameter')}
                    </th>
                  </Tooltip>
                  <Tooltip content={APP_TOOLTIPS.TOOLTIP_DF_CLEARANCE_DIAMETER.Content}>
                    <th onClick={() => this.props.setSortBy('DF')}>
                      {APP_TEXTS.ANCHOR_SELECTION_DF.Content} {this.getSortingArrow('DF')}
                    </th>
                  </Tooltip>
                  <th onClick={() => this.props.setSortBy('Beta')}>
                    {APP_TEXTS.ANCHOR_SELECTION_UTILIZATION.Content} {this.getSortingArrow('Beta')}
                  </th>
                  <th onClick={() => this.props.setSortBy('NameOfCombination')}>
                    {APP_TEXTS.ANCHOR_SELECTION_NAME.Content} {this.getSortingArrow('NameOfCombination')}
                  </th>
                </tr>
              )}
            </thead>

            <tbody className="tbody">
              {this.filteredData().map(item => {
                if (this.props.appType === APP_TYPES.REBAR_REINFORCEMENT) {
                  return (
                    <ConnectedRowRebar
                      key={JSON.stringify(item)}
                      item={item}
                      onClick={() => this.props.setActive(item)}
                      activeItem={this.props.selectedItem}
                      owner={this}
                    />
                  );
                } else {
                  return (
                    <ConnectedRow
                      key={JSON.stringify(item)}
                      item={item}
                      onClick={() => this.props.setActive(item)}
                      activeItem={this.props.selectedItem}
                      owner={this}
                    />
                  );
                }
              })}
            </tbody>
          </table>
        </section>
      </div>
    );
  }

  filteredData(skipFilter) {
    return this.props.grid.filter((item) => {
      var { status, anchorType, steelType, product, diameter, productRange } = this.props.filters;

      if (skipFilter) {
        switch (skipFilter) {
          case Filters.status: { status = ALL; break; }
          case Filters.anchorType: { anchorType = ALL; break; }
          case Filters.steelType: { steelType = ALL; break; }
          case Filters.product: { product = ALL; break; }
          case Filters.diameter: { diameter = ALL; break; }
          case Filters.productRange: { productRange = ALL; break; }
          default: break;
        }
      }

      /* eslint-disable eqeqeq */
      return (
        ((!status || status === ALL) || RESULTS[status].indexOf(item.Status) > -1) &&
        ((!anchorType || anchorType === ALL) || anchorType == item.AnchorFamily) &&
        ((!steelType || steelType === ALL) || (item.Filters_Data && item.Filters_Data[STEEL_TYPES[steelType]])) &&
        ((!product || product === ALL) || product == item.AnchorProduct) &&
        ((!diameter || diameter === ALL) || diameter == item.AnchorDiameter) &&
        ((!productRange || productRange === ALL) || productRange == item.AnchorProductRange)
      );
      /* eslint-enable eqeqeq */
    }).sort(compareBy(this.props.sortBy, this.props.isReverse, this.props.designStandard));
  }

  clearFilter = () => {
    // this.setState({
    //   results: ALL,
    //   anchorType: ALL,
    //   steelType: ALL,
    //   products: ALL,
    //   diameters: ALL,
    //   productRange: ALL
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.status, ALL);
    this.props.setFilter(Filters.anchorType, ALL);
    this.props.setFilter(Filters.steelType, ALL);
    this.props.setFilter(Filters.product, ALL);
    this.props.setFilter(Filters.diameter, ALL);
    this.props.setFilter(Filters.productRange, ALL);
  };

  chooseResult = value => {
    // this.setState({
    //   results: value || []
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.status, value || []);
  };

  chooseAnchorType = value => {
    // this.setState({
    //   anchorType: value || null
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.anchorType, value || null);
  };

  chooseSteelType = value => {
    // this.setState({
    //   steelType: value || null
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.steelType, value || null);
  };

  chooseProducts = value => {
    // this.setState({
    //   products: value || null
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.product, value || null);
  };

  chooseDiameter = value => {
    // this.setState({
    //   diameters: value || null
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.diameter, value || null);
  };

  chooseProductRange = value => {
    // this.setState({
    //   productRange: value || null
    // }, this.selectFirstResult);
    this.props.setFilter(Filters.productRange, value || null);
  };

  scrollToSelectedRow = () => {
    if (this.selectedRow !== undefined && this.selectedRow !== null) {
      const tableBodyNode = this.selectedRow.parentElement;
      const tableHeadNode = tableBodyNode.parentElement.firstChild;
      tableBodyNode.scrollTop = this.selectedRow.offsetTop - tableHeadNode.clientHeight;
    }
  }

  selectFirstResult = () => {
    let data = this.filteredData();
    if (data && data.length && data.length > 0) {
      this.props.setActive(data[0]);
      this.props.scrollToSelectedResult(true);
    }
  }

  getSortingArrow(columnName) {
    if (this.props.sortBy === columnName) {
      if (this.props.isReverse)
        return "↓";
      else
        return "↑";
    } else {
      return "↕";
    }
  }

  // sortBy (key) {
  //   this.setState(oldState => {
  //     return {
  //       sortBy: key,
  //       isReverse: oldState.sortBy === key ? !oldState.isReverse : false
  //     };
  //   });
  // }

}

const Phi = () => <span>&Phi;</span>;

function Row({ item, onClick, activeItem, distanceUnit, designStandard, owner }) {
  return (
    <tr onClick={onClick} className={`${JSON.stringify(activeItem) === JSON.stringify(item) && 'active'}`}
      ref={JSON.stringify(activeItem) === JSON.stringify(item) ? (ref) => { owner.selectedRow = ref; } : null}>
      <td className="text-center">
        <span className={STATUS_LIST[item.Status || 0]} />
      </td>
      <td>
        {item.AnchorProduct}
      </td>
      <td>
        {item.AnchorType + (item.isChemical && isICCorCSA(designStandard) ?
          (" x " + unitTransform(+item.hef)
            .from(defaultUnits.DISTANCE)
            .to(distanceUnit === DISTANCE.INCHES ? DISTANCE.FRACTIONAL_INCHES : distanceUnit))
          : ""
        )}
      </td>
      <td className="text-center">
        {item.AnchorDiameter && isICCorCSA(designStandard) ?
          (unitTransform(item.AnchorDiameter)
            .from(defaultUnits.DISTANCE)
            .to(distanceUnit === DISTANCE.INCHES ? DISTANCE.FRACTIONAL_INCHES : distanceUnit)) :
          ((item.AnchorCode !== "BAR" && "M") + prepareNum(item.AnchorDiameter, false))}
      </td>
      <td className="text-center">
        {item.DF && unitTransform(+item.DF).from(defaultUnits.DISTANCE).to(distanceUnit).toFixed(isICCorCSA(designStandard) ? 2 : 1)}
      </td>
      <td className="text-center">
        {item.Beta === 0 ? '***' : (item.Beta * 100).toFixed(isICCorCSA(designStandard) ? 1 : 2) + '%'}
      </td>
      <td className="text-center">
        {item.NameOfCombination}
      </td>
    </tr>
  );
}
const ConnectedRow = connect(state => ({
  distanceUnit: state.main.units.distance,
  designStandard: state.main.localization.designStandard
}))(Row);


function RowRebar({ item, onClick, activeItem, distanceUnit, owner }) {
  let anchorageLbd = null;

  if (item.Status) {
    if (item.FireCalculation) {
      anchorageLbd = Math.max(item.Lbd, item.Lbd_fi);
    } else {
      anchorageLbd = item.Lbd;
    }

    if (Number.isFinite(+anchorageLbd)) {
      anchorageLbd = unitTransform(anchorageLbd).from(defaultUnits.DISTANCE).to(distanceUnit);
    }
  }

  return (
    <tr onClick={onClick} className={`rebar ${JSON.stringify(activeItem) === JSON.stringify(item) && 'active'}`}
      ref={JSON.stringify(activeItem) === JSON.stringify(item) ? (ref) => { owner.selectedRow = ref; } : null}>
      <td className="text-center">
        <span className={item.Status ? STATUS_LIST[1] : STATUS_LIST[2]} />
      </td>
      <td>
        {item.DisplayName}
      </td>
      <td>
        {prepareNum(item.Diameter, false)}
      </td>
      <td className="text-center">
        {prepareNum(anchorageLbd, true)}
      </td>
    </tr>
  );
}
const ConnectedRowRebar = connect(state => ({
  distanceUnit: state.main.units.distance
}))(RowRebar);

export function compareBy(key, isReverse, designStandard) {
  return function (a, b) {
    var reverseOrder = isReverse;
    // Special cases:
    if (key === 'Beta') {
      // Number(designStandard) === standardList["Masonry"] && a.BetaN_Masonry > 0 && a.BetaV_Masonry ? 1.2 : 1;
      const maximumBetaA = getInteractionMaximumValue(a, designStandard) / 100;
      //Number(designStandard) === standardList["Masonry"] && b.BetaN_Masonry > 0 && b.BetaV_Masonry ? 1.2 : 1;
      const maximumBetaB = getInteractionMaximumValue(b, designStandard) / 100;
      if (a[key] <= 0 && b[key] > maximumBetaB) return 1; //(isReverse ? -1 : 1);  beta has priority over ***
      else if (b[key] <= 0 && a[key] > maximumBetaA) return -1; //(isReverse ? 1 : -1);  beta has priority over ***
      //(isReverse ? -1 : 1);  beta under 100% has priority
      // beta under maximum has priority only if the anchor is suitable (e.g. overall beta < 1.2 but tensile beta > 1)
      else if ((a[key] <= 0 || a[key] > maximumBetaA || a['Status'] === 0) && (b[key] > 0 && b[key] <= maximumBetaB && b['Status'] === 1))
        return 1;
      else if ((b[key] <= 0 || b[key] > maximumBetaB || b['Status'] === 0) && (a[key] > 0 && a[key] <= maximumBetaA && a['Status'] === 1))
        return -1;
      // reverse not suitable anchors so that the top not suitable anchor has the lowest beta when sorting by descending beta
      else if (a['Status'] === 0 && b['Status'] === 0)
        reverseOrder = !reverseOrder;
      // else follow the normal cases
    }
    else if (key === 'Status') { // (0 - anchor not suitable, 1 - anchor suitable, 2 - anchor not calculated) 
      if (a[key] === 2) return 1;//(isReverse ? -1 : 1);
      else if (b[key] === 2) return -1;//(isReverse ? 1 : -1);
      // else reverse the normal cases since 0 = not suitable && 1 = suitable
      else
        reverseOrder = !reverseOrder;
      // else if (isReverse) { 
      //   if (a[key] < b[key]) return -1;
      //   if (a[key] > b[key]) return 1;
      // } else {
      //   if (a[key] < b[key]) return 1;
      //   if (a[key] > b[key]) return -1;
      // }
    }
    else if (key === 'Lbd') {
      if (a[key] === 0 || a['Status'] === false) return 1;
      else if (b[key] === 0 || b['Status'] === false) return -1;
      // else follow the normal cases
    }

    // Normal cases:
    if (reverseOrder) {
      if (a[key] < b[key]) return 1;
      if (a[key] > b[key]) return -1;
    } else {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
    }

    return 0;
  };
}

const mapState = state => ({
  grid: state.main.appType === APP_TYPES.WOOD_CONNECTION
    ? (state.webServices.calculate.grid &&
      state.webServices.calculate.grid.AnchorDesignResults &&
      isArray(state.webServices.calculate.grid.AnchorDesignResults)
      ? state.webServices.calculate.grid.AnchorDesignResults
      : [])
    : (isArray(state.webServices.calculate.grid)
      ? state.webServices.calculate.grid
      : []),
  filterOptions: (() => {
    const filterOptions = {
      anchorType: {},
      products: {},
      diameters: {},
      productRanges: {}
    };

    const gridData = state.main.appType === APP_TYPES.WOOD_CONNECTION
      ? state.webServices.calculate.grid &&
      state.webServices.calculate.grid.AnchorDesignResults
      : state.webServices.calculate.grid;

    if (gridData && isArray(gridData)) {
      gridData.forEach(i => {
        filterOptions.anchorType[i.AnchorFamily] = i.AnchorFamily;
        filterOptions.products[i.AnchorProduct] = i.AnchorProduct;
        filterOptions.diameters[i.AnchorDiameter] = i.AnchorDiameter;
        filterOptions.productRanges[i.AnchorProductRange] = i.AnchorProductRange;
      });
    }

    return filterOptions;
  })(),
  selectedItem: state.selectors.calculate[state.main.appType] ? state.selectors.calculate[state.main.appType].gridSelectedItem : null,
  appType: state.main.appType,
  sortBy: state.webServices.calculate.sortBy,
  isReverse: state.webServices.calculate.isReverse,
  isWaiting: state.webServices.calculate.isWaiting,
  designStandard: state.main.localization.designStandard,
  distanceUnit: state.main.units.distance,
  refreshSelectedResult: state.selectors.calculate[state.main.appType] ?
    (state.selectors.calculate[state.main.appType].scrollToSelectedResult || false) : false,
  filters: state.selectors.calculate[state.main.appType] && state.selectors.calculate[state.main.appType].filters ?
    state.selectors.calculate[state.main.appType].filters : {
      [Filters.anchorType]: ALL,
      [Filters.diameter]: ALL,
      [Filters.product]: ALL,
      [Filters.productRange]: ALL,
      [Filters.status]: ALL,
      [Filters.steelType]: ALL
    },
  language: state.main.localization.language,
  steelTypes: state.webServices.calculate.steelTypes || []
});

const mapDispatch = dispatch => ({
  setActive: value => dispatch(setCalculateGridSelectedItem(value)),
  setSortBy: value => dispatch(setSortingMethod(value, null)),
  scrollToSelectedResult: value => dispatch(scrollToSelectedResult(value)),
  setFilter: (type, value) => dispatch(setCalculateFilter(type, value)),
  getErrorMessages: (value) => dispatch(getErrorMessages(value))
});

export default connect(mapState, mapDispatch)(CalculateAnchorSelection);



// WEBPACK FOOTER //
// ./src/views/Calculate/components/CalculateAnchorSelection/index.js